import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { faDownload, faTrash, faEdit, faUserCheck, faBan, faSpinner } from '@fortawesome/free-solid-svg-icons';

export const EditButton = ({ title="Edit", onClick, row }) => {
    return (
        <button
            className={clsx(
                'flex items-center',
                'text-[#50A1CA] hover:text-[#50A1CA]/70',
                'dark:text-[#50A1CA] dark:hover:text-[#50A1CA]/70',
                'font-medium',
                'px-3 py-2 rounded-xl',
                'border border-[#50A1CA] dark:border-[#50A1CA]',
                'bg-[#50A1CA]/10 hover:bg-[#50A1CA]/20',
                'dark:bg-[#50A1CA]/10 dark:hover:bg-[#50A1CA]/20',
                'transition-colors'
            )}
            title={title}
            onClick={() => onClick(row.original)}
        >
            <FontAwesomeIcon icon={faEdit} className="w-3 h-3" />
        </button>
    );
};

export const DeleteButton = ({ title="Delete", onClick, row }) => {
    return (
        <button
            className={clsx(
                'flex items-center',
                'text-red-500 hover:text-red-500/70',
                'dark:text-red-500 dark:hover:text-red-500/70',
                'font-medium',
                'px-3 py-2 rounded-xl',
                'border border-red-500 dark:border-red-500',
                'bg-red-500/10 hover:bg-red-500/20',
                'dark:bg-red-500/10 dark:hover:bg-red-500/20',
                'transition-colors'
            )}
            title={title}
            onClick={() => onClick(row.original)}
        >
            <FontAwesomeIcon icon={faTrash} className="w-3 h-3" />
        </button>
    );
};

export const DownloadButton = ({ title="Download", onClick, row, isLoading = false }) => {
    return (
        <button
            className={clsx(
                'flex items-center',
                'text-[#282A74] hover:text-[#282A74]/70',
                'dark:text-[#209DD8] dark:hover:text-[#209DD8]/70',
                'font-medium',
                'px-3 py-2 rounded-xl',
                'border border-[#282A74] dark:border-[#209DD8]',
                'bg-[#282A74]/10 hover:bg-[#282A74]/20',
                'dark:bg-[#209DD8]/10 dark:hover:bg-[#209DD8]/20',
                'transition-colors',
                isLoading && 'opacity-50 cursor-not-allowed'
            )}
            title={title}
            onClick={() => !isLoading && onClick(row.original)}
        >
            <FontAwesomeIcon 
                icon={isLoading ? faSpinner : faDownload} 
                className={clsx('w-3 h-3', isLoading && 'animate-spin')} 
            />
        </button>
    );
};

export const EnableUserButton = ({ onClick, row }) => {
    return (
        <button
            className={clsx(
                'flex items-center',
                'text-[#282A74] hover:text-[#282A74]/70',
                'dark:text-[#209DD8] dark:hover:text-[#209DD8]/70',
                'font-medium',
                'px-3 py-2 rounded-xl',
                'border border-[#282A74] dark:border-[#209DD8]',
                'bg-[#282A74]/10 hover:bg-[#282A74]/20',
                'dark:bg-[#209DD8]/10 dark:hover:bg-[#209DD8]/20',
                'transition-colors'
            )}
            title="Enable User"
            onClick={() => onClick(row.original)}
        >
            <FontAwesomeIcon icon={faUserCheck} className="w-3 h-3" />
        </button>
    );
};

export const DisableUserButton = ({ onClick, row }) => {
    return (
        <button
            className={clsx(
                'flex items-center',
                'text-red-500 hover:text-red-500/70',
                'dark:text-red-500 dark:hover:text-red-500/70',
                'font-medium',
                'px-3 py-2 rounded-xl',
                'border border-red-500 dark:border-red-500',
                'bg-red-500/10 hover:bg-red-500/20',
                'dark:bg-red-500/10 dark:hover:bg-red-500/20',
                'transition-colors'
            )}
            title="Disable User"
            onClick={() => onClick(row.original)}
        >
            <FontAwesomeIcon icon={faBan} className="w-3 h-3" />
        </button>
    );
};
